// @flow
import * as React from "react";
import {Alert, Container, Stack} from "@mui/material";
import SiteWrapper from "../SiteWrapper.react";
import '../css/Dashboard.css'
import {useAuthContext} from "../contexts/AuthenticationContext";
import "react-datepicker/dist/react-datepicker.css";
import {useTranslation} from "react-i18next";
import UserService from "../services/user.service";
import ProjectService from "../services/project.service";
import { useHistory} from "react-router-dom";
import { TrueffortButtonSmall } from "../MUIstyle/MUICustom";
import {PieChart} from "@mui/icons-material";
import GlobalReportTabs from "../components/globalReports/GlobalReportTabs";
import InteroperabilityService from "../services/interoperabilty.service";
import { MIN_LEVEL_ADMIN } from "../util/Constants";
import { useMemo, useEffect, useState } from "react";
import ReportsService from '../services/reports.service';
import useReportPrivacy from '../hooks/useReportPrivacy';
import CustomLoader from '../components/custom/CustomLoader';

function GlobalReport() {
  const {user} = useAuthContext();
  const features = user?.instance?.license ? user?.instance?.license?.features : {};
  const {t} = useTranslation();
  const history = useHistory();
  const userService = useMemo(() => new UserService(), []);
  const [users, setUsers] = useState([]);
  const privacy = useReportPrivacy();
  const [optionsRevision, setOptionsRevision] = useState(-1);
  const [optionsTab, setOptionsTab] = useState(null);
  const [optionsError, setOptionsError] = useState(false);
  const projectService = useMemo(() => new ProjectService(), []);
  const interoperabilityService = useMemo(() => new InteroperabilityService(), []);
  const [projects, setProjects] = useState([]);
  const [lastUserActivity, setLastUserActivity] = useState(null);
  const [tabName, setTabName] = useState((features.globalReportProjectsStatus || features.reportProjectsEvaluation) ? "projects" :
    (features.userProductivityReportItemsPerformed || features.worksheetsUsers || features.reportBenchmark) ? "users" : "");

  useEffect(() => {
    if ((!user.instance.activeByPayment && user.instance.trial === null)
      || (!user.instance.activeByPayment && user.instance.trial !== null
      && user.instance.trial.isExpired && !user.instance.trial.hasBought)) {
      history.push("/payment");
    }
    fillProjects();
    document.title = "TruEffort <" + user.email + ">";
  }, []);

  useEffect(() => {
    let active = true;
    setOptionsRevision(-1);
    setUsers([]);
    setOptionsError(false);
    if (!privacy.ready) return;
    const request = tabName === 'users' ? new ReportsService().userOptions() : userService.getAllComplete();
    request.then(({ data: response }) => {
      if (!response.success || !Array.isArray(response.data)) throw new Error('Invalid user options');
      if (active) {
        setUsers(response.data);
        setOptionsTab(tabName);
        setOptionsRevision(privacy.revision);
      }
    }).catch(() => { if (active) setOptionsError(true); });
    return () => { active = false; };
  }, [privacy.ready, privacy.revision, tabName, userService]);

  const fillProjects = () => {
    projectService.getAll().then(({data: response}) => {
      if (user.role.accessLevel >= MIN_LEVEL_ADMIN) {
        interoperabilityService.writeAsyncInstance().then((res) => {});
      }
      if (response.data != null && Array.isArray(response.data)) {
        setProjects(response.data);
      }
    });
  }

  return (
    <SiteWrapper>
      <Container maxWidth='xl' sx={{ marginTop: '20px' }}>
        <div className="title">
          <div className="title-small">{tabName == "users" ? t("Productivity") : t("reports.projects.total_all_time")}</div>
          <h2 id="idTitle">{tabName == "users" ? t("Reports") : t("reports.global_analysis")}</h2>
        </div>
        <Stack direction={{ xs: 'column', sm:'row', md: 'row'}} spacing={1} >
          {(features.globalReportProjectsStatus || features.reportProjectsEvaluation) && <TrueffortButtonSmall 
            id="idTabProjectReport"
            color="secondary"
            variant={tabName == "projects" ? "contained" : "outlined"}
            onClick={() => setTabName("projects")}
            startIcon={<PieChart sx={{width: '0.9em'}}/>}
            style={{marginRight: "0.2em"}}>
            {t("Projects.title")}
          </TrueffortButtonSmall>}
          {(features.userProductivityReportItemsPerformed  || features.worksheetsUsers || 
            features.reportBenchmark) && <TrueffortButtonSmall 
            id="idTabUserReport"
            color="secondary"
            variant={tabName == "users" ? "contained" : "outlined"}
            onClick={() => setTabName("users")}
            startIcon={<PieChart sx={{width: '0.9em'}}/>}
            style={{marginRight: "0.2em"}}>
            {t("Users.title")}
          </TrueffortButtonSmall>}
        </Stack>
        {(privacy.error || optionsError) ? <Alert severity="error">{t('configuration.report_privacy_error')}</Alert> :
        !privacy.ready || optionsRevision !== privacy.revision || optionsTab !== tabName ? <CustomLoader /> : <GlobalReportTabs
          key={`${tabName}-${privacy.revision}`}
          user={user}
          allProjects={projects}
          allUsers={users}
          setLastUserActivity={setLastUserActivity}
          report={tabName}
        />}
      </Container>
    </SiteWrapper>
  );
}

export default GlobalReport;
